<div class="row ss-top-menu">
  <div class="col-sm-6">
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">
      Dashboard <i class="rightArrow fa fa-angle-right"></i>
    </span>
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">
      Promo Packages
    </span>
  </div>
</div>

<div class="mt-4 container-set">

</div>



// WEBPACK FOOTER //
// ./src/app/platform/organisation/create-promo-packages/create-promo-packages.component.html